import React from "react";
import { ViewBackIcon } from "../../common/icons/Icon";
import { withRouter } from "react-router-dom";
import { getTime } from "../../common/utils/Functions";

const UserReportListItem = ({ history, item }) => {
  return (
    <div className="br-10 notification-section p-2 my-2  ">
      <div className="d-flex align-items-center justify-content-between ">
        <div className=" d-flex align-items-center pe-0">
          <span>
            <img
              className="notification-user-img "
              src={
                item &&
                item.user_details &&
                item.user_details.profile_image_path
              }
              alt="notifyimg"
            />
          </span>
          <div className="ps-sm-3 ps-2">
            <p className="mb-0 common-text text-black wrap f-w-600 ">
              {item && item.message}
            </p>
            <p className="mb-0 common-text xxs-font wrap">
              {getTime(item.created_at)}
            </p>
          </div>
        </div>
        <div className=" ps-0">
          <button
            className="px-sm-3 px-2 py-2  atech-fade-button"
            onClick={() => {
              history.push(`/admin/user/report/view/${item.id}`);
            }}
          >
            <span className="pe-2">
              <ViewBackIcon />
            </span>
            <span className=" d-inline-block fs-Montserrat ">view</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(UserReportListItem);
